
import { FaUserFriends, FaProjectDiagram, FaCloud, FaServer } from 'react-icons/fa'

import Layout from '../../components/layout'
import SectionHeading from '../../components/SectionHeading'
import ServiceCard from "../../components/servicecard";

const delivery = [
  { title: "Bemanning", icon: FaUserFriends, description: "Vi blir en del av er interna IT-avdelning för avlastning och spetskompetens, från 20 % till 100 %, med jour och beredskap vid kritiska perioder." },
  { title: "Projekt", icon: FaProjectDiagram, description: "Väldefinierade och tidsbegränsade leveranser med tydligt scope och leverabler, från arkitektur och design till implementation och utbildning." },
  { title: "Tjänst", icon: FaCloud, description: "AceOps, AceNoc och AceNaaS. Tjänster där drift ingår och där ansvaret fördelas efter era behov." },
  { title: "Hårdvara & Mjukvara", icon: FaServer, description: "Rätt produkt på rätt plats, leverantörsoberoende. Direktköp eller finansiering via tredjepart." }
]

export default function OfferPage() {
  return (
    <Layout>
      <div id="offer" className="section flex flex-col gap-10 sm:gap-14">
        <SectionHeading
          eyebrow="Erbjudande"
          title={<>Ace:a det <span className="text-sky-500">med</span> oss</>}
        >
          <p>Vi hjälper er att planera, implementera och optimera moderna nätverk.</p>
          <p>
            Behöver ni förstärka ert team med rätt kompetens? Söker ni expertis för att lösa tekniska eller organisatoriska utmaningar? Eller kanske en helhetslösning där vi tar hand om allt? Vi erbjuder flexibla samarbeten på det sätt som passar er bäst.
          </p>
        </SectionHeading>

        <div className="flex flex-col gap-4 sm:gap-6">
          <h3 className="text-xl font-semibold">Hur vill ni samarbeta med oss?</h3>
          <div className="grid gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
            {delivery.map((item, index) => (
              <ServiceCard
                key={item.title}
                index={index}
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
